<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <nav aria-label="breadcrumb text-center pt-lg-5 pt-3">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Hotel & Restaurants</li>
                        </ol>
                    </nav> -->
                    <h1 alt="Restaurant Satisfaction survey" class="h1-title mt-3">Create Enjoyable Experiences For Your Guests</h1>
                    <p class="sub-text mt-3">With CViewSurvey, measure how satisfied the guests are with your services and how you can improve the experience for them.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">
                            Request a Demo
                        </a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="Hotel Survey" title="" src="assets/hotel-and-restaurent.svg">

                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="mb-5 pb-5">
        <div class="container">
            <div class="col-md-12">
                <div class="featured video card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="Hotel feedback survey" class="text-center h2-title mb-4">Hotel and Restaurant</h2>
                        <p class="text-center sub-text">Customer Satisfaction plays a vital role in the development of any Industry. A satisfied customer is a happy customer capable of turning into your Hotel or Restaurant’s branding ambassador. Our application assists you to comprehend
                            the perception of your customers regarding the Hotel or Restaurant, and help you enhance the guest experience, service levels, and clients' needs. These restaurant and hotel surveys capture customer opinions,look through their
                            reviews that lead to service improvisation.</p>
                    </div>
                </div>
                <!-- play-video -->
                <div class="play-video">
                    <a class="video-play-button" (click)="scroll(target)">
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    </section>

    <section class="mt-5 mb-lg-5 pt-lg-5 pb-lg-5">
        <div class="container mb-lg-5 ">
            <h3 alt="customer feedback survey hotels" class="text-center">Take advantage of CViewSurvey Application to:</h3>
        </div>

        <div class="features-screenshot-right " style="margin-bottom: 60px;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid mb-lg-0 mb-3" alt="Restaurant Survey" src="assets/hotel-restaturant_01.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="customer feedback survey hotels" class="feature-heading">GATHER CUSTOMER DATA</h3>
                        <p class="sub-text text-justify">When you gather your customer's personal data, you can give them complimentary services on their special days, and they tend to have a good relationship with you. You can mail or message them updates, coupons, and exciting offers
                            and retain them forever.</p>

                        <h5 class="feature-heading mt-4">PROVIDE ROOM FOR IMPROVEMENT</h5>
                        <p class="sub-text text-justify">Prevent negative experiences from spreading like wildfires and immediately work on improving and rectifying respondents negative experiences. With CViewSurvey, track these problems and address them quickly.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left" style="margin-bottom: 60px;">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-6">
                        <h3 alt="customer feedback survey hotels" class="feature-heading">CUSTOMIZE THE SURVEYS TO REPRESENT YOUR BRAND</h3>
                        <p class="sub-text text-justify">With the help of our application, you can completely customize the survey experience. From vibrant colours and attractive survey themes, you get to customise the surveys inside-out.</p>

                        <h5 class="feature-heading mt-4">SET YOUR PRIORITIES RIGHT</h5>
                        <p class="text-justify">Hotel and Restaurant employee surveys can help your staff to focus on the areas that often get undermined. Conduct employee satisfaction surveys and track what your administration feels about their business.</p>
                    </div>
                    <div class="col-md-6 text-right">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid mb-lg-0 mb-3" alt="Hotel Staff Survey" src="assets/staff_focusing.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right " style="margin-bottom: 60px;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid mb-lg-0 mb-3" alt="Online Survey App" src="assets/prevent.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="customer feedback survey hotels" class="feature-heading">CAPITALIZE ON CUSTOMER FEEDBACK FOR GROWTH</h3>
                        <p class="sub-text text-justify">Act on negative responses, eliminate the weak links in your hotel/restaurant and move forward towards an enhanced and satisfactory experience for your customers and ultimately your business.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container text-center my-5">
            <p class="sub-text">While the guests with good experience would hardly share their view with their relatives, friends & acquaintances, on the other aspect the unfortunate or bad experience are likely to be expressed loud & vocal about your services. Since bad
                experiences are contagious and can impact your brand value in the market, you have to address the problems real quick. It also aids you to gain knowledge regarding the current market trends and modified preferences of the customers, and
                you can take further business decisions accordingly.</p>
        </div> -->
    </section>

    <!-- video-section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9 mt-lg-4" autoplay [muted]="'muted'" controls loop>
                            <source class="embed-responsive-item" src="" type="video/mp4">
                            Your browser does not support the video tag.
                        </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>